import { getAlertAuthorities } from "./authorities"

export const readAlert = defineAbility((user) => {
  const authorities = getAlertAuthorities(user)
  return authorities.includes("ALERT_READ")
})

export const editAlert = defineAbility((user) => {
  const authorities = getAlertAuthorities(user)
  return authorities.includes("ALERT_EDIT")
})

export const createAlert = defineAbility((user) => {
  const authorities = getAlertAuthorities(user)
  return authorities.includes("ALERT_CREATE")
})

export const deleteAlert = defineAbility((user) => {
  const authorities = getAlertAuthorities(user)
  return authorities.includes("ALERT_DELETE")
})
